import axios from "axios";
import AuthenticationFailureHandler from "../../utils/AuthenticationFailureHandler";
import { getHeaders } from "../../utils/AuthorizationUtil";
import { BASE_PRICING_URL } from "../../utils/EmpUtil";
import { is401 } from "../../errors/ErrorConstants";

export default class PricingClient {
  static pricingUrl = BASE_PRICING_URL;

  static getNscPricing(user, catalogIds, marketId = null) {
    let url;

    if (marketId !== null) {
      url = `${this.pricingUrl}/nsc/${marketId}/pricing?catalogIds=${catalogIds}`;
    } else {
      url = `${
        this.pricingUrl
      }/${user.generateResourcePath()}/pricing?catalogIds=${catalogIds}`;
    }

    return axios
      .get(url, getHeaders(user.token))
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        if (is401(error)) {
          AuthenticationFailureHandler.execute();
        }
        return Promise.reject(error);
      });
  }

  static getFutureNscPricing(user, catalogIds) {
    const url = `${
      this.pricingUrl
    }/${user.generateResourcePath()}/futurepricing?catalogIds=${catalogIds}`;
    return axios
      .get(url, getHeaders(user.token))
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        if (is401(error)) {
          AuthenticationFailureHandler.execute();
        }
        return Promise.reject(error);
      });
  }

  static getDealerPricing(user, lang, catalogIds) {
    let url = `${this.pricingUrl}/dealer/${user.market}/pricing?dealerId=${user.dealerId}&catalogIds=${catalogIds}`;
    if (lang) {
      url = url + `&lang=${lang}`;
    }
    return axios
      .get(url, getHeaders(user.token))
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        if (is401(error)) {
          AuthenticationFailureHandler.execute();
        }
        return Promise.reject(error);
      });
  }

  static getFutureDealerPricing(user, lang, catalogIds) {
    let url = `${this.pricingUrl}/dealer/${user.market}/futurepricing?dealerId=${user.dealerId}&catalogIds=${catalogIds}`;
    if (lang) {
      url = url + `&lang=${lang}`;
    }
    return axios
      .get(url, getHeaders(user.token))
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        if (is401(error)) {
          AuthenticationFailureHandler.execute();
        }
        return Promise.reject(error);
      });
  }

  static getFutureIncentives(user, data) {
    const url = `${this.pricingUrl}/pricing/incentives`;
    return axios
      .post(url, data, getHeaders(user.token))
      .then((response) => response.data)
      .catch((error) => {
        if (is401(error)) {
          AuthenticationFailureHandler.execute();
        }
        return Promise.reject(error);
      });
  }

  static getDealerFutureIncentives(user, data) {
    const url = `${this.pricingUrl}/pricing/dealer/incentives?dealerId=${user.dealerId}`;
    return axios
      .post(url, data, getHeaders(user.token))
      .then((response) => response.data)
      .catch((error) => {
        if (is401(error)) {
          AuthenticationFailureHandler.execute();
        }
        return Promise.reject(error);
      });
  }

  static getNscPreferenceForPriceChange(market, user) {
    const url = `${this.pricingUrl}/nsc/${market}/preference`;

    return axios
      .get(url, getHeaders(user.token))
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        if (is401(error)) {
          AuthenticationFailureHandler.execute();
        }
        return Promise.reject(error);
      });
  }

  static saveNscPreference(user, catalogId, params) {
    const url = `${this.pricingUrl}/nsc/${user.market}/preference?catalogId=${catalogId}&userId=${user.userId}`;
    return axios
      .post(url, params, getHeaders(user.token))
      .then((response) => response.status)
      .catch((error) => {
        if (is401(error)) {
          AuthenticationFailureHandler.execute();
        }
        return Promise.reject(error);
      });
  }

  static saveDealerPricingCall(user, data, dealerIds, catalogIds) {
    const url = `${this.pricingUrl}/dealer/${user.market}/pricing?dealerIds=${dealerIds}&catalogId=${catalogIds}`;
    return axios
      .post(url, data, getHeaders(user.token))
      .then((response) => response.status)
      .catch((error) => {
        if (is401(error)) {
          AuthenticationFailureHandler.execute();
        }
        return Promise.reject(error);
      });
  }

  static saveFutureDealerPricingCall(user, data, dealerIds, catalogIds) {
    const url = `${this.pricingUrl}/dealer/${user.market}/futurepricing?dealerIds=${dealerIds}&catalogId=${catalogIds}`;
    return axios
      .post(url, data, getHeaders(user.token))
      .then((response) => response.status)
      .catch((error) => {
        if (is401(error)) {
          AuthenticationFailureHandler.execute();
        }
        return Promise.reject(error);
      });
  }

  static saveNscPricingCall(user, data, marketId = null) {
    let url;

    if (marketId !== null) {
      url = `${this.pricingUrl}/nsc/${marketId}/pricing?userId=${user.userId}`;
    } else {
      url = `${this.pricingUrl}/${user.generateResourcePath()}/pricing?userId=${
        user.userId
      }`;
    }
    return axios
      .post(url, data, getHeaders(user.token))
      .then((response) => response.status)
      .catch((error) => {
        if (is401(error)) {
          AuthenticationFailureHandler.execute();
        }
        return Promise.reject(error);
      });
  }
}
